import AboutMePage from "@components/about";
import { RevealProvider } from "@components/animations";
import CertificationPage from "@components/certification";
import ContactsPage from "@components/contacts";
import EducationPage from "@components/education";
import ExperiencePage from "@components/experience";
import HomePage from "@components/home";
import DrawerAppBar from "@components/layout/drawer";
import PortfolioPage from "@components/portfolio";
import { lazy, Suspense } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import CanonicalUrl from "./CanonicalUrl";
import ScrollToTop from "./ScrollToTop";
import NotFoundPage from "./not-found-page";

// Isolated animation demo — code-split so it never loads on the real site.
const AnimationDemoPage = lazy(() => import("../animation-demo"));

// V1 — the earlier, pre-animation snapshot of the portfolio (also code-split).
const V1App = lazy(() => import("../v1"));

function DrawerAppBarWrapper() {
  return <DrawerAppBar>{null}</DrawerAppBar>;
}
const router = createBrowserRouter([
  {
    // Demo lives outside the portfolio chrome so the original layout,
    // navbar and pages are completely untouched while previewing.
    path: "/animation-demo",
    element: (
      <Suspense fallback={<div style={{ minHeight: "100vh" }} />}>
        <AnimationDemoPage />
      </Suspense>
    ),
  },
  {
    // V1 — the pre-animation snapshot, mounted at its own path so both
    // versions can coexist. The splat hands sub-path routing to that subtree.
    path: "/v1/*",
    element: (
      <Suspense fallback={<div style={{ minHeight: "100vh" }} />}>
        <V1App />
      </Suspense>
    ),
  },
  {
    path: "/",
    element: (
      <RevealProvider>
        <ScrollToTop />
        <CanonicalUrl />
        <DrawerAppBarWrapper />
      </RevealProvider>
    ),
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: "about",
        element: <AboutMePage />,
      },
      {
        path: "portfolio",
        element: <PortfolioPage />,
      },
      {
        path: "experience",
        element: <ExperiencePage />,
      },
      {
        path: "certification",
        element: <CertificationPage />,
      },
      {
        path: "education",
        element: <EducationPage />,
      },
      {
        path: "contact",
        element: <ContactsPage />,
      },
      {
        path: "*",
        element: <NotFoundPage />,
      },
    ],
  },
]);

export default function UserRoutes() {
  return <RouterProvider router={router} />;
}
